import React, { useEffect, useState } from 'react'
import {  Header, Form, TextArea, Button, Loader, Dimmer, Message } from 'semantic-ui-react'


import './Contact.css'

import bgImage2 from "../../images/BG2.png";
import contact from "../../images/Contact.png"



export const Contact = () => {
  const [showErrMsg, setShowErrMsg] = useState<string | null>(null);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState<boolean>(false);
  const [form, setForm] = useState<{
    fullName: string,
    contactNo: string,
    emailId: string,
    about: string
  }>({
    fullName: "",
    contactNo: "",
    emailId: "",
    about: "",
  })

  useEffect(() => {
    if (showSuccessMsg) {
      setTimeout(() => {
        setShowSuccessMsg(false);
      },2000)
    }
  }, [showSuccessMsg])
  const handleChange = (e: any, {value, name}: any) => {
    setForm({
      ...form,
      [name]: value
    })
  }

  const submitForm = async () => {
    let url = process.env.REACT_APP_FORM_URL;
    console.log(url,'ssssssss');
    
    if (!url) {
      return;
    }

    url = url.replace("{{FullName}}", form.fullName);
    url = url.replace("{{ContactNo}}", form.contactNo);
    url = url.replace("{{EmailID}}", form.emailId);
    url = url.replace("{{About}}", form.about);
    setShowLoader(true);
    const iframe = document.createElement('iframe')
    iframe.src = url;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    setTimeout(() => {
      document.body.removeChild(iframe);
      setShowLoader(false);
      setForm({
        fullName: "",
        contactNo: "",
        emailId: "",
        about: ""    
      })
      setShowSuccessMsg(true);
    }, 1000)
  }

  const validator = (name: string, value: string) => {
    switch(name) {
      case "fullName":
        return value.length >= 3;
      case "collegeName":
        return value.length >= 3;
      case "contactNo":
        return String(value)
          .toLowerCase()
          .match(
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
          );
      case "emailId":
        return String(value)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        }
  }

  const handleSubmit = async () => {
    if (form.fullName && form.about && form.contactNo && form.emailId) {
      if (!validator("fullName",form.fullName)) {
        setShowErrMsg("Full Name should be atleast 3 characters");
        return;
      }

     
      if (!validator("contactNo", form.contactNo)) {
        setShowErrMsg("Invalid Contact No");
        return;
      }

      if (!validator("emailId", form.emailId)) {
        setShowErrMsg("Invalid Email Id");
        return;
      }
      if (!validator("collegeName", form.about)) {
        setShowErrMsg("About should be atleast 3 characters");
        return;
      }


      setShowErrMsg(null);
      await submitForm();
    } else {
      setShowErrMsg("* fields are required")
    }
  }

  return (
    <div className='apply'   style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'cover', background: 'cover' }}>
      <div  className='apply__left1'>
      <div className='apply__left'>
      

        <Header as={'h1'} size='huge'>
        Contact Us
        </Header>
        <p>
          Gain enough knowledge about us
        </p>
        <img  className="img" src={contact} alt='Qshikshak'   />
      </div>
      <div className='apply__right'>
        <Form onSubmit={handleSubmit}>
          <Form.Input
            fluid
            className='input'
            label='Full Name*'
            placeholder='Full Name'
            name="fullName"
            onChange={handleChange}
            value={form.fullName}
          />
          <Form.Input
            fluid
            label='Contact No*'
            placeholder='Contact No'
            name="contactNo"
            onChange={handleChange}
            value={form.contactNo}
          />
          <Form.Input
            fluid label='Email Id*'
            placeholder='Email Id'
            name="emailId"
            onChange={handleChange}
            value={form.emailId}
          />
          <Form.Field
            control={TextArea}
            label='About'
            placeholder='...'
            name="about"
            onChange={handleChange}
            value={form.about}
          />
          {showErrMsg && <div style={{color: "red"}}>{showErrMsg}</div>}
          <Dimmer active={showLoader}>
            <Loader />
          </Dimmer>
          <div className='apply__btn'>
            <Form.Field primary control={Button}  className='button'>
              Submit
            </Form.Field>
          </div>
        </Form>
        {showSuccessMsg && <Message positive>
          <Message.Header>Application successfully submitted!!</Message.Header>
        </Message>}
      </div>
      </div>
    </div>
  )
}